import { Link } from "react-router-dom";
import type { ProjectListItem } from "@/mocks/admin/projects";
import ProjectStatusBadge from "@/pages/projects/components/StatusBadge";

type Props = {
  projects: ProjectListItem[];
  loading: boolean;
};

export default function MoveHistory({ projects, loading }: Props) {
  return (
    <div className="bg-white border border-ink-100 rounded-lg">
      <div className="px-5 py-3 border-b border-ink-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h3 className="font-display text-sm font-bold text-ink-900">Move history</h3>
          {projects.length > 0 && (
            <span className="text-[10px] font-bold bg-cream-100 text-ink-700 px-1.5 py-0.5 rounded">
              {projects.length}
            </span>
          )}
        </div>
      </div>

      {loading ? (
        <div className="py-10 text-center text-sm text-ink-400">Loading moves…</div>
      ) : projects.length === 0 ? (
        <div className="py-12 text-center">
          <div className="w-12 h-12 rounded-full bg-cream-100 text-ink-400 mx-auto flex items-center justify-center mb-2">
            <i className="ri-archive-line text-xl"></i>
          </div>
          <div className="text-sm font-semibold text-ink-700">No moves yet</div>
          <div className="text-xs text-ink-500 mt-1">
            This customer hasn't had a project scheduled yet.
          </div>
        </div>
      ) : (
        <ul className="divide-y divide-ink-100">
          {projects.map((p) => (
            <li key={p.id}>
              <Link
                to={`/projects/${p.id}`}
                className="flex items-center gap-4 px-5 py-3.5 hover:bg-cream-50 cursor-pointer"
              >
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap mb-0.5">
                    <span className="font-mono text-[11px] font-bold text-ink-500">
                      {p.id}
                    </span>
                    <ProjectStatusBadge status={p.status} size="sm" />
                  </div>
                  <div className="text-sm font-semibold text-ink-900 truncate">
                    {p.moveType}
                  </div>
                  <div className="text-[11px] text-ink-500 mt-0.5 truncate">
                    {p.date} · {p.fromCity} → {p.toCity}
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <div className="text-sm font-bold text-ink-900 tabular-nums">
                    ${p.total.toLocaleString()}
                  </div>
                  <div
                    className={`text-[10px] font-semibold ${
                      p.depositPaid ? "text-emerald-600" : "text-amber-600"
                    }`}
                  >
                    {p.depositPaid ? "Deposit paid" : "Deposit pending"}
                  </div>
                </div>
                <i className="ri-arrow-right-s-line text-ink-300 text-lg shrink-0"></i>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}